//方便表单处理操作模式

import Permission from "../../../api/smp/auth/Permission.js";
import Mode from "./Mode.js";

export default class ModeHelper{

    bill = null;
    inited = false;
    //必须包含按钮编号，按钮模式号
    //模式号用于自动识别支持的模式
    //按钮编号用于自定义支持的模式号
    billSupportedAction = null;

    modeMap  = new Map();

    constructor(bill){
        this.bill = bill;
    }

    //1 获取指定表单支持的操作模式
    //比如查找表单A,支持 保存  浏览  导出 删除  编辑  审核 等
    async loadBillSupportedAction(){
        let me = this;

        console.log('loadBillSupportedAction.');
        console.log(this.bill.getMenuId());
        let queryButtonPriviledgeResp = await Permission.queryButtonPriviledge(this.bill.getMenuId());
        console.log("load button previledge returned;");

        console.log(queryButtonPriviledgeResp);
        
        let data = queryButtonPriviledgeResp.data;
        if((!data)||(!(data.code))||(data.code!=200)){
            let msg=data.msg;
            msg = ((!msg)||(msg==''))?'获取菜单按钮情况失败':msg;
            throw new Error(msg);
            return;
        }
        if((!data.data)||(!data.data.buttonPriviledges)){
            throw new Error('获取菜单按钮情况失败(无会话数据)');
            return;
        }
        let modeMap = new Map();
        this.billSupportedAction = data.data.buttonPriviledges;
        this.billSupportedAction.forEach(function(buttonPriviledge){
            modeMap.set(buttonPriviledge.buttonTypeId,buttonPriviledge);
        });
		this.modeMap = modeMap;   
    }

    async getBillSupportAction(){
        if(! this.billSupportedAction){
            await this.loadBillSupportedAction();
        }
        return this.billSupportedAction;
    }

    getQueryConditionSwitchButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_QUERY);
    }

    getQueryConditionSwitchOpened(){
        return this.bill.getShowQueryCondition();
    }
    getQueryConditionSwitchClosed(){
        return !this.bill.getShowQueryCondition();
    }

    getQueryButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_QUERY);
    }

    getQueryButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_QUERY);
    }

    getAddLowLevelButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_ADD_LOW_LEVEL);
    }
    

    getAddLowLevelButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_ADD_LOW_LEVEL);
    }

    getAddSameLevelButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_ADD_SAME_LEVEL);
    }
    
    getAddSameLevelButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_ADD_SAME_LEVEL);
    }

    getStopButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_STOP);
    }
    
    getStopButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_STOP);
    }

    getRestoreButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_RESTORE);
    }
    
    getRestoreButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_RESTORE);
    }

    getCreateButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_CREATE);
    }
    

    getCreateButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_CREATE);
    }

    getEditButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_EDIT);
    }

    getEditButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_EDIT);
    }

    getSaveButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_SAVE);
    }

    getSaveButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_SAVE);
    }

    getDeleteButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_DELETE);
    }

    getDeleteButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_DELETE);
    }

    getAuditButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_AUDIT);
    }

    getAuditButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_AUDIT);
    }

    getCancelAuditButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_CANCEL_AUDIT);
    }

    getCancelAuditButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_CANCEL_AUDIT);
    }

    getVoidButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_VOID);
    }

    getVoidButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_VOID);
    }

    getCancelVoidButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_CANCEL_VOID);
    }

    getCancelVoidButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_CANCEL_VOID);
    }

    getPutOnButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_PUT_ON);
    }

    getPutOnButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_PUT_ON);
    }

    getWithdrawButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_WITHDRAW);
    }

    getWithdrawButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_WITHDRAW);
    }

    getExportDetailButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_EXPORT_DETAIL);
    }

    getExportDetailButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_EXPORT_DETAIL);
    }

    getBrowseDetailButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_BROWSE_DETAIL);
    }

    getBrowseDetailButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_BROWSE_DETAIL);
    }

    getRefreshButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_REFRESH);
    }

    getRefreshlButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_REFRESH);
    }

    getExportButtonExists(){
        return this.getButtonExists(Mode.SUPPORT_EXPORT);
    }

    getExportButtonPermited(){
        return this.getButtonPermited(Mode.SUPPORT_EXPORT);
    }

    getButtonExists(mode){
        let btn = this.modeMap.get(""+mode);
        if(btn)
            return true;
        return false;
    }

    getButtonPermited(mode){
        let btn = this.modeMap.get(""+mode);
        if(btn){
            if(btn.hasPriviledge && btn.hasPriviledge=='Y')
                return true;
        }
        return false;
    }

    getButtonTextPermited(text){
        let billSupportedActions = this.getBillSupportAction();
        if(!billSupportedActions){
            return false;
        }
        for(var idx in billSupportedActions){
            let action = billSupportedActions[idx];
            if(action.name == text)
                return true;
        }
        return false;
    }


}